import { INITIAL_CAR_SEARCH } from '@/utils/constants';

export function setState(state, [field, value]) {
  state[field] = value;
}

export function setModels(state, models) {
  state.modelList = models;
}

export function setMakes(state, makeList) {
  state.makeList = makeList;
}

export function setSelected(state, [field, value]) {
  if (!state.selected.hasOwnProperty(field)) {
    return;
  }
  state.selected[field] = value;
}

export function resetSelected(state) {
  state.selected = { ...INITIAL_CAR_SEARCH };
}

export function setNewUsedSelected(state, value) {
  state.selected.newUsed = value;
  state.selected.modelId = undefined;
  state.selected.transmission = undefined;
  state.selected.year = undefined;
}

export function setMakeSelected(state, makeId) {
  state.selected.makeId = makeId;
  state.selected.bodyType = undefined;
  state.selected.modelId = undefined;
  state.selected.transmission = undefined;
  state.selected.year = undefined;
}

export function setBodyTypeSelected(state, bodyTypeId) {
  state.selected.bodyType = bodyTypeId;
  state.selected.modelId = undefined;
  state.selected.transmission = undefined;
  state.selected.year = undefined;
}

export function setModelSelected(state, modelId) {
  state.selected.modelId = modelId;
  state.selected.transmission = undefined;
  state.selected.year = undefined;
}

export function setTransmission(state, transmissionId) {
  state.selected.transmission = transmissionId;
  state.selected.year = undefined;
}
